import React, {Component} from 'react';
import "./Search.css"

class Search extends Component {
    render() {
        return (
            <div className={"search-container"} data-testid="admin.search.container">
                <div className={"search-bar"} data-testid="admin.search.bar">
                    <i className="fa fa-search search-icon"/>
                    <input onChange={(e) => this.props.setSearchTerm(e.target.value)} value={this.props.searchTerm} className={"pi-input-search"}
                           data-testid="admin.search.input"
                           type={"text"}
                           placeholder={"Search instance type, email, domain or job info"}
                    />
                </div>
            </div>
        );
    }
}

export default Search;